/**
 * Application Routes Schema
 * Single source of truth for all route paths
 * Import and use these constants instead of hardcoding route strings
 */

export const ROUTES = {
  // Auth Routes
  AUTH: {
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    VERIFY_OTP: "/verify-otp",
    CREATE_PASSWORD: "/create-password",
    CHANGE_PASSWORD: "/change-password",
  },

  // Dashboard Routes
  DASHBOARD: {
    HOME: "/",
    ORDER_MANAGEMENT: "/order",
    PRODUCT_MANAGEMENT: "/product",
    RETURNS: "/returns",
    ACCOUNT_SETTINGS: "/account-settings",
    CHANGE_PASSWORD: "/change-password",
    DESIGN_GUIDE: "/design-guide",
    MANUFACTURES: "/manufactures",
    MANUFACTURES_ADD: "/manufactures/add",
    MANUFACTURES_VIEW: (id: string) => `/manufactures/${id}`,
    CUSTOMERS: "/customers",
    CUSTOMERS_ADD: "/customers/add",
    CUSTOMERS_VIEW: (id: string) => `/customers/${id}`,
    PAYOUTS: "/payouts",
    CMS: "/cms",
    CMS_TERMS: "/cms/terms",
    CMS_PRIVACY: "/cms/privacy",
    CMS_HELP: "/cms/help",
    SETTINGS: "/settings",
    SETTINGS_ACCOUNT: "/settings/account",
    NOTIFICATION_MANAGEMENT: "/settings/notification",
  },

  // Root
  ROOT: "/",
} as const;

/**
 * Type-safe route type for navigation
 */
export type RouteKey = typeof ROUTES[keyof typeof ROUTES][keyof typeof ROUTES[keyof typeof ROUTES]];
